export const data = {
  heading: "Native vs. Cross-Platform Development",
  paragraph: "The debate usually comes down to a trade-off between upfront cost and long-term quality. While cross-platform tools can save on cost of initial development, they often encounter lagging and maintenance debt when the OS updates.",
  tableData: {
    thead: [
      "Feature",
      "Native",
      "Cross-Platform (React Native / Flutter)",
    ],
    tbody: [
      [
        "Performance",
        "Best (60–120fps native rendering)",
        "Good, but occasional lag/jank",
      ],
      [
        "User Experience","Platform-authentic feel","Generic or slightly off gestures"
      ],
      [
        "Hardware Access","Direct & Immediate","Limited by third-party plugins"
      ],
      [
        "Initial Cost","Higher (Dual codebases)","30–50% less upfront"
      ],[
        "Maintenance","Highly stable & scalable","Risks of bridge breakage during OS updates"
      ]
    
    ],
  },
};